import toast, { ToastOptions } from 'react-hot-toast';

const toaster = {
  success: (message: string, options?: ToastOptions) => toast.success(message, options),
  error: (message: string, options?: ToastOptions) => toast.error(message, options),
  info: (message: string, options?: ToastOptions) => toast(message, options),
  warning: (message: string, options?: ToastOptions) =>
    toast(message, {
      ...options,
      icon: '⚠️',
      style: {
        background: '#FFF3DC',
        color: '#805B10',
        ...options?.style,
      },
    }),
};

export default toaster;
